export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (window as any)._env_?.BACKEND_URL ||
  "http://localhost:8083";
